import { IAppState } from '../../../redux';
import { selectAddressEditingRestrictionData } from './selectAddressEditingRestrictionData';
import { selectIsAddressEditingCountdownVisible } from './selectIsAddressEditingCountdownVisible';

export const selectAddressEditingCountdownMessage = (state: IAppState): string | null => {
  const isCountdownVisible = selectIsAddressEditingCountdownVisible(state);
  const editingRestrictionData = selectAddressEditingRestrictionData(state);

  return (isCountdownVisible && editingRestrictionData?.message) || null;
};
